import axios from 'axios';
import { getContentType } from '../../utils/api.utils';

const runtimeBaseUrl = (typeof window !== 'undefined' && (window as any).API_URL) || process.env.REACT_APP_API_URL || ''; // Пустая строка = относительные URL к текущему домену

const $api = axios.create({
  withCredentials: false,
  baseURL: runtimeBaseUrl,
  headers: getContentType(),
});

export default $api;
